import React from "react";

import { MdmDeviceDto, useGetAllDevicesByProjectQuery } from "gql/generated/types";
import { Link } from "react-router-dom";
import { TableColumn } from "utils/types";
import DeviceStatus from "../components/DeviceStatus";
import MainTable from "../components/MainTable";
import useProjectContext from "../hooks/useProjectContext";

const Devices = () => {
  const {projectId, project} = useProjectContext();

  const { data: deviceData, loading } = useGetAllDevicesByProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });

  const edit = (rowData: MdmDeviceDto) => (
    <Link to={`${rowData.id}`} title="Device Info">
      {rowData.identifier}
    </Link>
  );

  const handleStatus = (rowData: MdmDeviceDto) => <DeviceStatus device={rowData} />

  const columns: TableColumn<MdmDeviceDto>[] = [
    { field: "identifier", header: "Identifier",body: edit, sortable: true, filter: true },
    {
      field: "objectRelation.mdmObject.title",
      header: "Object Code",
      sortable: true,
      filter: true,
    },
    {
      field: "objectRelation.roleInObject",
      header: "Type",
      body: rowData =>
        project?.mdmProjectById.configuration?.deviceConfiguration.measurementTypes?.find(
          type => type?.id === rowData.objectRelation?.roleInObject
        )?.title ?? "",
      sortable: true,
    },
    { field: "config.title", header: "Config", sortable: true },
    {
      header: "Status",
      body: handleStatus,
      sortable: true,
      sortField: "boundDatasets.all.length",
      hideInFile: true,
    },
  ];

  return (
    <MainTable
      columns={columns}
      data={(deviceData?.mdmDevicesByProjectId ?? []) as MdmDeviceDto[]}
      tableType="device"
      searchFields={["identifier", "tags"]}
      loading={loading}
    />
  );
};

export default Devices;